import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { FactorService } from 'src/app/factors/services/factor.service';
import { AccommodationFormService } from 'src/app/trip-calculator/services/accommodation-form.service';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';

@Component({
  selector: 'app-select-custom-accommodation-factor',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-custom-accommodation-factor.component.html',
})
export class SelectCustomAccommodationFactorComponent
  implements OnInit, OnDestroy
{
  accommodationFormService = inject(AccommodationFormService);

  factorService = inject(FactorService);

  items: CategoryItem[] = [];

  ngOnInit() {
    this.initializeItems();
    this.accommodationFormService.createCustomFactorControl();
  }
  ngOnDestroy() {
    this.accommodationFormService.destroyCustomFactorControl();
  }

  initializeItems() {
    this.items = [];
    for (const factor of this.accommodationFormService.accommodationFactor()) {
      this.items.push({
        value: factor.id,
        label: factor.name,
      });
    }
  }

  get value() {
    const value = this.accommodationFormService.accommodationForm.get(
      'customEmissionFactorId',
    )?.value;
    return value ? value : '';
  }

  set value(value: string) {
    this.accommodationFormService.accommodationForm
      .get('customEmissionFactorId')
      ?.setValue(value);
  }
}
